var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API, { graphqlOperation } from '@aws-amplify/api';
import { virtualUpdateCallStats, } from '@alucio/aws-beacon-amplify/src/graphql/mutations';
export var PARTICIPANT_ROLE;
(function (PARTICIPANT_ROLE) {
    PARTICIPANT_ROLE[PARTICIPANT_ROLE["HOST"] = 0] = "HOST";
    PARTICIPANT_ROLE[PARTICIPANT_ROLE["ATTENDEE"] = 1] = "ATTENDEE";
})(PARTICIPANT_ROLE || (PARTICIPANT_ROLE = {}));
export var AUDIO_SOURCE;
(function (AUDIO_SOURCE) {
    AUDIO_SOURCE["COMPUTER"] = "Use Computer Audio";
    AUDIO_SOURCE["PHONE"] = "Call In";
})(AUDIO_SOURCE || (AUDIO_SOURCE = {}));
export var CONTENT_MODE;
(function (CONTENT_MODE) {
    CONTENT_MODE[CONTENT_MODE["SCREEN_SHARE"] = 0] = "SCREEN_SHARE";
    CONTENT_MODE[CONTENT_MODE["CONTENT_SHARE"] = 1] = "CONTENT_SHARE";
    CONTENT_MODE[CONTENT_MODE["NONE"] = 2] = "NONE";
})(CONTENT_MODE || (CONTENT_MODE = {}));
const updateCallStats = createAsyncThunk('virtualRoom/updateCallStats', (stats, { getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33;
    try {
        const roomState = getState().virtualRoom;
        const statsData = {
            video: {
                send: {
                    bandwidthActual: (_c = (_b = (_a = stats === null || stats === void 0 ? void 0 : stats.video) === null || _a === void 0 ? void 0 : _a.sendStats) === null || _b === void 0 ? void 0 : _b.bandwidth) === null || _c === void 0 ? void 0 : _c.actual,
                    bandwidthAvailable: (_f = (_e = (_d = stats === null || stats === void 0 ? void 0 : stats.video) === null || _d === void 0 ? void 0 : _d.sendStats) === null || _e === void 0 ? void 0 : _e.bandwidth) === null || _f === void 0 ? void 0 : _f.available,
                    fractionLost: (_j = (_h = (_g = stats === null || stats === void 0 ? void 0 : stats.video) === null || _g === void 0 ? void 0 : _g.sendStats) === null || _h === void 0 ? void 0 : _h.fractionLost) === null || _j === void 0 ? void 0 : _j.fractionLost,
                    rtt: (_m = (_l = (_k = stats === null || stats === void 0 ? void 0 : stats.video) === null || _k === void 0 ? void 0 : _k.sendStats) === null || _l === void 0 ? void 0 : _l.latency) === null || _m === void 0 ? void 0 : _m.rtt,
                    jitter: (_q = (_p = (_o = stats === null || stats === void 0 ? void 0 : stats.video) === null || _o === void 0 ? void 0 : _o.sendStats) === null || _p === void 0 ? void 0 : _p.latency) === null || _q === void 0 ? void 0 : _q.jitter,
                    overallQuality: (_r = stats === null || stats === void 0 ? void 0 : stats.video) === null || _r === void 0 ? void 0 : _r.send,
                },
                recv: {
                    bandwidthActual: (_u = (_t = (_s = stats === null || stats === void 0 ? void 0 : stats.video) === null || _s === void 0 ? void 0 : _s.recvStats) === null || _t === void 0 ? void 0 : _t.bandwidth) === null || _u === void 0 ? void 0 : _u.actual,
                    bandwidthAvailable: (_x = (_w = (_v = stats === null || stats === void 0 ? void 0 : stats.video) === null || _v === void 0 ? void 0 : _v.recvStats) === null || _w === void 0 ? void 0 : _w.bandwidth) === null || _x === void 0 ? void 0 : _x.available,
                    fractionLost: (_0 = (_z = (_y = stats === null || stats === void 0 ? void 0 : stats.video) === null || _y === void 0 ? void 0 : _y.recvStats) === null || _z === void 0 ? void 0 : _z.fractionLost) === null || _0 === void 0 ? void 0 : _0.fractionLost,
                    rtt: (_3 = (_2 = (_1 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _1 === void 0 ? void 0 : _1.recvStats) === null || _2 === void 0 ? void 0 : _2.latency) === null || _3 === void 0 ? void 0 : _3.rtt,
                    overallQuality: (_4 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _4 === void 0 ? void 0 : _4.recv,
                },
            },
        };
        if (roomState.localParticipant.audio === AUDIO_SOURCE.COMPUTER) {
            statsData.audio = {
                send: {
                    bandwidthActual: (_7 = (_6 = (_5 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _5 === void 0 ? void 0 : _5.sendStats) === null || _6 === void 0 ? void 0 : _6.bandwidth) === null || _7 === void 0 ? void 0 : _7.actual,
                    bandwidthAvailable: (_10 = (_9 = (_8 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _8 === void 0 ? void 0 : _8.sendStats) === null || _9 === void 0 ? void 0 : _9.bandwidth) === null || _10 === void 0 ? void 0 : _10.available,
                    fractionLost: (_13 = (_12 = (_11 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _11 === void 0 ? void 0 : _11.sendStats) === null || _12 === void 0 ? void 0 : _12.fractionLost) === null || _13 === void 0 ? void 0 : _13.fractionLost,
                    rtt: (_16 = (_15 = (_14 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _14 === void 0 ? void 0 : _14.sendStats) === null || _15 === void 0 ? void 0 : _15.latency) === null || _16 === void 0 ? void 0 : _16.rtt,
                    jitter: (_19 = (_18 = (_17 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _17 === void 0 ? void 0 : _17.sendStats) === null || _18 === void 0 ? void 0 : _18.latency) === null || _19 === void 0 ? void 0 : _19.jitter,
                    overallQuality: (_20 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _20 === void 0 ? void 0 : _20.send,
                },
                recv: {
                    bandwidthActual: (_23 = (_22 = (_21 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _21 === void 0 ? void 0 : _21.recvStats) === null || _22 === void 0 ? void 0 : _22.bandwidth) === null || _23 === void 0 ? void 0 : _23.actual,
                    bandwidthAvailable: (_26 = (_25 = (_24 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _24 === void 0 ? void 0 : _24.recvStats) === null || _25 === void 0 ? void 0 : _25.bandwidth) === null || _26 === void 0 ? void 0 : _26.available,
                    fractionLost: (_29 = (_28 = (_27 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _27 === void 0 ? void 0 : _27.recvStats) === null || _28 === void 0 ? void 0 : _28.fractionLost) === null || _29 === void 0 ? void 0 : _29.fractionLost,
                    rtt: (_32 = (_31 = (_30 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _30 === void 0 ? void 0 : _30.recvStats) === null || _31 === void 0 ? void 0 : _31.latency) === null || _32 === void 0 ? void 0 : _32.rtt,
                    overallQuality: (_33 = stats === null || stats === void 0 ? void 0 : stats.video) === null || _33 === void 0 ? void 0 : _33.recv,
                },
            };
        }
        const callParams = {
            joinToken: roomState.localParticipant.joinToken,
            stats: statsData,
        };
        yield API.graphql(graphqlOperation(virtualUpdateCallStats, callParams));
    }
    catch (err) {
        // To log in the logger tool
        console.error(`error submitting stats to service ${JSON.stringify(err)}`);
    }
}));
const initialState = {
    localParticipant: {
        attendeeId: '',
        audio: AUDIO_SOURCE.COMPUTER,
        joinToken: '',
        name: '',
        phonePin: '',
        role: PARTICIPANT_ROLE.ATTENDEE,
        videoIdentity: '',
        joinedAt: new Date(),
    },
    contentMode: CONTENT_MODE.NONE,
    isLocalMicEnabled: true,
    isVideoEnabled: true,
    dialInNumbers: {},
    meetingId: '',
    remoteParticpants: [],
    roomName: '',
    roomState: 'disconnected',
    selectedAudioMode: AUDIO_SOURCE.COMPUTER,
};
const virtualRoomSlice = createSlice({
    name: 'VirtualState',
    initialState: initialState,
    reducers: {
        initializeRoom: (state, action) => {
            state.dialInNumbers = action.payload.dialInNumbers;
            state.meetingId = action.payload.meetingId;
            state.roomName = action.payload.roomName;
            state.localParticipant.role = action.payload.role;
            return state;
        },
        onReceiveRoomCredentials: (state, action) => {
            state.localParticipant.attendeeId = action.payload.attendeeId;
            state.localParticipant.joinToken = action.payload.joinToken;
            state.localParticipant.name = action.payload.name;
            state.localParticipant.phonePin = action.payload.phonePin;
            return state;
        },
        onRoomConnected: (state, action) => {
            state.localParticipant.videoIdentity = action.payload.localParticipantIdentity;
            state.localParticipant.joinedAt = new Date();
            state.roomState = 'connected';
            return state;
        },
        onRoomReJoining: (state) => {
            state.roomState = 'reconnecting';
            return state;
        },
        participantConnected: (state, action) => {
            const participant = action.payload;
            const identity = participant.identity;
            const [attendeeId, participantRole, name] = identity.split('.');
            if (participantRole === 'phone') {
                // audio participant what we do is we update the existing participant
                if (attendeeId === state.localParticipant.attendeeId) {
                    // Local User's Audio Just connected
                    state.localParticipant.audio = AUDIO_SOURCE.PHONE;
                    state.selectedAudioMode = AUDIO_SOURCE.PHONE;
                    state.localParticipant.phoneIdentity = identity;
                }
                else {
                    state.remoteParticpants.forEach((participant) => {
                        if (participant.attendeeId === attendeeId) {
                            participant.audio = AUDIO_SOURCE.PHONE;
                            participant.phoneIdentity = identity;
                        }
                    });
                }
            }
            else if (participantRole === 'video') {
                // Make sure participant doesn't already exist
                const existingAttendee = state.remoteParticpants.find((x) => x.videoIdentity === identity);
                // regular video participant
                if (!existingAttendee) {
                    const newParticipant = {
                        attendeeId,
                        audio: AUDIO_SOURCE.COMPUTER,
                        joinedAt: new Date(),
                        name,
                        role: attendeeId === 'host' ? PARTICIPANT_ROLE.HOST : PARTICIPANT_ROLE.ATTENDEE,
                        videoIdentity: identity,
                    };
                    state.remoteParticpants = [...state.remoteParticpants, newParticipant];
                }
            }
            else {
                throw new Error(`Unknown video participant role encountered: ${participantRole}`);
            }
            return state;
        },
        participantDisconnected: (state, action) => {
            const identity = action.payload;
            const [attendeeId, participantRole] = identity.split('.');
            if (participantRole === 'phone') {
                // User disconnected phone
                if (attendeeId === state.localParticipant.attendeeId) {
                    state.localParticipant.audio = AUDIO_SOURCE.COMPUTER;
                    state.localParticipant.phoneIdentity = undefined;
                }
                else {
                    const participant = state.remoteParticpants.find((participant) => participant.attendeeId === attendeeId);
                    if (participant) {
                        participant.audio = AUDIO_SOURCE.COMPUTER;
                        participant.phoneIdentity = undefined;
                    }
                }
            }
            else {
                state.remoteParticpants = state.remoteParticpants.filter((participant) => participant.attendeeId !== attendeeId);
            }
            return state;
        },
        setContentMode: (state, action) => {
            state.contentMode = action.payload;
            return state;
        },
        setLocalMicEnabled: (state, action) => {
            state.isLocalMicEnabled = action.payload;
            return state;
        },
        setLocalVideoEnabled: (state, action) => {
            state.isVideoEnabled = action.payload;
            return state;
        },
        setSelectedAudioMode: (state, action) => {
            state.selectedAudioMode = action.payload;
            return state;
        },
        clearState: () => {
            return initialState;
        },
    },
    extraReducers: {},
});
export default virtualRoomSlice;
export const virtualRoomActions = Object.assign(Object.assign({}, virtualRoomSlice.actions), { updateCallStats });
//# sourceMappingURL=virtualRoom.js.map